class QuillButtonHandler {
  constructor(quill) {
    this.quill = quill;
    this.range = null;
    
    this.quill.on('selection-change', (range) => {
      if (range) {
        this.range = range;
      }
    });
  }
  
  insertButton() {
    const range = this.range || this.quill.getSelection();
    if (!range) return;
    
    // Get selected text or use default
    const selectedText = this.quill.getText(range.index, range.length);
    const buttonText = selectedText.trim() || 'Button';
    
    // Prompt for URL like the regular link button
    const buttonUrl = prompt('Enter link URL:', 'https://');
    if (!buttonUrl) return;
    
    // If there's selected text, replace it with the button link
    if (range.length > 0) {
      this.quill.deleteText(range.index, range.length);
    }
    
    // Insert the button text
    this.quill.insertText(range.index, buttonText);
    
    // Format as link
    this.quill.formatText(range.index, buttonText.length, 'link', buttonUrl);
    
    // Add button classes
    this.quill.formatText(range.index, buttonText.length, 'class', 'btn btn-primary');
    
    // Move cursor after the button
    this.quill.setSelection(range.index + buttonText.length);
  }
}

export default QuillButtonHandler;
